import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { currentUserData } from '../components/CurrentUserInfo';

interface currentUserDataState {
  userData: currentUserData | null;
}

const initialCurrentUserDataState: currentUserDataState = {
  userData: null,
};


export const userDataSlice = createSlice({
  name: 'unsavedUserData',
  initialState: initialCurrentUserDataState,
  reducers: {
    setUserData: (state, action: PayloadAction<currentUserData>) => {
      state.userData = action.payload;
    },
    setPhoneVerified: (state, action: PayloadAction<boolean>) => {
        state.userData!.phoneVerified = action.payload;
      },
      setFirstName: (state, action: PayloadAction<string>) => {
        state.userData!.firstName = action.payload;
      },
      setStreetAddress: (state, action: PayloadAction<string>) => {
        state.userData!.address = action.payload;
      },
      setCreationDate: (state, action: PayloadAction<string>) => {
        state.userData!.creationDate = action.payload;
      },
      setNumCryptoOriginated: (state, action: PayloadAction<number>) => {
        state.userData!.CryptosOriginated = action.payload;
      },
      setNumCryptoAlloted: (state, action: PayloadAction<number>) => {
        state.userData!.CryptosAlloted = action.payload;
      },

    clearUserData: (state) => {
      state.userData = null;
    },
  },
});


export const { setUserData, setPhoneVerified, setFirstName, setStreetAddress, 
    setCreationDate, setNumCryptoOriginated, clearUserData, setNumCryptoAlloted
   } = userDataSlice.actions;


export default {
    userData: userDataSlice.reducer,
};